import angular from 'angular';
import { routes } from './routes';
import { react2angular } from 'react18-react2angular';
import GasRelatorioDetailstView from './details';
import GasRelatoriosListView from './list';
import { useContext } from '@components';
import GasCarteiraView from './carteira';
import GasRecebimentosView from './recebimentos';
import GasFaturacaoPosteriorView from './faturacaoposterior';
import GasMapaFaturacaoView from './mapafaturacao';
import GasReconciliacaoEdpView from './reconciliacaoedp';
export default angular
    .module('app.gas.relatorios', [])
    .config(routes)
    .component('gasRelatorioDetailsView', react2angular(GasRelatorioDetailstView, [], ['$state', 'GasService']))
    .component('gasCarteiraView', react2angular(GasCarteiraView, [], ['$state', 'AuthorizationService', 'GasService', 'UIService']))
    .component('gasRecebimentosView', react2angular(GasRecebimentosView, [], ['$state', 'GasService', 'UIService']))
    .component('gasFaturacaoPosteriorView', react2angular(GasFaturacaoPosteriorView, [], ['$state', 'GasService', 'UIService']))
    .component('gasMapaFaturacaoView', react2angular(GasMapaFaturacaoView, [], ['$state', 'GasService', 'UIService']))
    .component('gasReconciliacaoEdpView', react2angular(GasReconciliacaoEdpView, [], ['$state', 'GasService', 'UIService']))
    .component('gasRelatoriosListView', react2angular(useContext.use(GasRelatoriosListView), [], ['$state', 'GasService', 'UIService'])).name;
